import * as React from 'react'

import { cn } from '@/lib/utils'

/**
 * Keyboard shortcut hint. Renders inline next to body text or in a
 * command-palette / hint row. Uses tabular numerals so combinations
 * like ⌘K line up.
 */
function Kbd({ className, ...props }: React.ComponentProps<'kbd'>) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-sm border border-border bg-muted px-1 font-mono text-[10px] font-medium text-muted-foreground shadow-soft',
        className,
      )}
      {...props}
    />
  )
}

export { Kbd }
